import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CustomerOrderLineConfigurationReResolvingView } from "src/components/views/erp/sales/customerOrderLine/configurationReresolving/CustomerOrderLineConfigurationReResolvingView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/parts/costCalculation/configurableCustomerOrderLines")(
	{
		staticData: {
			title: i18n.t("configured_customer_order_lines"),
			legacyViewKey: "configurableCustomerOrderLinesPage",
		},
		component: RouteComponent,
	},
);

function RouteComponent() {
	return <CustomerOrderLineConfigurationReResolvingView />;
}
